// Build-time configuration (Vite env, VITE_* only).

/**
 * The first-party OAuth client. core-platform seeds exactly one,
 * 'vads-portal', with this id and an EMPTY redirect_uris array
 * (internal/db/migrations/0014_auth.up.sql:195-203) — a deployment must
 * register the portal's redirect URI before login works (web/README.md).
 */
export const OAUTH_CLIENT_ID: string =
  (import.meta.env.VITE_OAUTH_CLIENT_ID as string | undefined) || "00000000-0000-0000-0000-000000000001";

/**
 * The redirect URI sent with login. core-platform's flow returns the
 * authorization code in the JSON response rather than redirecting
 * (auth.go:164-168), so this is only matched against the registered list
 * (internal/auth/oauth.go validateClientAndRedirect); /auth/callback exists
 * as a route so the URI is a real page on this origin.
 */
export function oauthRedirectUri(): string {
  return (import.meta.env.VITE_OAUTH_REDIRECT_URI as string | undefined) || `${window.location.origin}/auth/callback`;
}

/**
 * Which environment this deployment serves (UX-DESIGN.md §4.6). The server
 * answers GET /v1/environment (G-46, 0055) and that answer wins; this build
 * setting is only the fallback while it loads or if it can't be fetched.
 */
export type DeploymentEnvironment = "live" | "test" | "unknown";
export const DEPLOYMENT_ENVIRONMENT: DeploymentEnvironment = (() => {
  const v = (import.meta.env.VITE_VADS_ENVIRONMENT as string | undefined)?.toLowerCase();
  return v === "live" || v === "test" ? v : "unknown";
})();

export const SUPPORT_EMAIL: string = (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined) || "support@vads.example";
